module.exports = __webpack_public_path__ + "img/UA.ce6f1f06.png";